import { extendTheme } from '@chakra-ui/react';
import { SelectionState } from './types';
const check = require('./assets/check.png');
const wool = require('./assets/wool.png');
const woolList = require('./assets/woolList.png');
const checkList = require('./assets/checkList.png');
const dischemlist = require("./assets/dischemlist.png")
const clickslist = require("./assets/clickslist.png")
const clicks = require('./assets/clicks.png')
const dischem = require('./assets/dischem.png')

export const MEAT_CATEGORIES = ["Beef", "Chicken", "Lamb", "Mutton", "Ostrich", "Pork", "Turkey", "Veal" ,"Venison"]
export const VALUE_UNITS = ["g", "ml"]

export const initialSelectionState: SelectionState = {
  current: {
    barcode: null,
    title: '',
    category: '',
    subCategories: {},
    brands: {},
    minVolume: -Infinity,
    maxVolume: Infinity,
    unit: null,
    stores: {
      woolworths: true,
      checkers: true,
      clicks: true,
      'Dis-chem': true
    },
  },
};

export const _INITIAL_RANKING_DETAILS = {
  bestValueProductId: '',
  bestValueProductAmount: Infinity,
  averageValueAmount: 0
}

export enum VolumeUnits {
  ml = 'ml',
  l = 'l',
  kg = 'kg',
  g = 'g',
  L = 'l',
  cm = 'cm',
  pack = 'pack',
  pk = 'pk',
  single = 'single',
  half = 'half',
  quarter = 'quarter',
  bag = 'bag',
  tray = 'tray',
  bunch = 'bunch',
  punnet = 'punnet',
  piece = 'piece',
}

export const customTheme = extendTheme({
  colors: {
    custom: {
      50: '#FFFFFF', // White
      100: '#F9FAFB', // Off-white
      200: '#F4F5F7', // Light gray
      300: '#E5E7EB', // Gray
      400: '#D1D5DB', // Dark gray
      500: '#9CA3AF', // Neutral
      600: '#6B7280', // Dark neutral
      700: '#4B5563', // Darker neutral
      800: '#374151', // Darker gray
      900: '#1F2937', // Black
    },
  },
  // Optionally, define other custom theme properties such as fonts, sizes, etc.
});

export const storeIcon: {[key: string]: any} = {
  woolworths: wool,
  checkers: check,
  clicks: clicks,
  'Dis-chem': dischem
};

export const storeListIcon : {[key: string]: any} = {
  woolworths: woolList,
  checkers: checkList,
  clicks: clickslist,
  'Dis-chem': dischemlist
};

export const imageWidths: { [key: string]: number } = {
  woolworths: 150,
  checkers: 100,
};

export const themeColours = {
  primary: "#1D3557",
  secondary: "#8e8e8e",
  tertiary: "#b8b8b8",
  green: "#3bb56c",
  red: "#b53b3b",
  background : '#1D355715'
}